import { Injectable } from '@angular/core';
import { PagedResult } from '../../../shared/index';
import { EventCustomRegField } from './event-custom-reg-field.model';
import { IEventV4CustomRegFieldService } from './ievent-v4-custom-reg-field.service';
import { EventsServiceApiService } from 'src/app/shared/api/events-service-api.service';

@Injectable({
  providedIn: 'root',
})
export class EventV4CustomRegFieldService implements IEventV4CustomRegFieldService {
  private _eventServiceBaseUrl: string = '/event/v2/itemcustomfield/';

  public constructor(private _eventApiService: EventsServiceApiService) {}

  public getEventCustomRegFields = (eventId: number, forceRefresh?: boolean): Promise<PagedResult> => {
    let url: string = `${
      this._eventServiceBaseUrl
    }search?EventId=${eventId.toString()}&PageSize=0&PageNumber=0&OrderBy=DisplayOrder:Asc,Id:Asc`;
    if (forceRefresh) {
      return this._eventApiService.get(url, this._eventApiService.getDefaultApiCacheOptionsForNoCache());
    }
    return this._eventApiService.get(url);
  };

  public getEventCustomRegField = (eventRegFieldId: number): Promise<EventCustomRegField> => {
    let url: string = this._eventServiceBaseUrl + eventRegFieldId.toString();
    return this._eventApiService.get(url);
  };

  public upsertEventCustomRegField = (eventCustomRegField: EventCustomRegField): Promise<number> => {
    if (eventCustomRegField.Id > 0) {
      return this._eventApiService.put(this._eventServiceBaseUrl, eventCustomRegField);
    }
    return this._eventApiService.post(this._eventServiceBaseUrl, eventCustomRegField);
  };

  public deleteEventCustomRegField = (eventCustomRegFieldId: number): Promise<void> => {
    let url: string = this._eventServiceBaseUrl + eventCustomRegFieldId.toString();
    return this._eventApiService.delete(url).then((): Promise<void> => {
      return Promise.resolve();
    });
  };

  public reorderCustomFields(eventId: number, orderedEventCustomFieldIds: Array<number>): Promise<any> {
    let url: string = `${this._eventServiceBaseUrl}event/${eventId}/order-custom-fields`;
    return this._eventApiService.post(url, orderedEventCustomFieldIds);
  }

  public validateCustomFieldDropDownValues(eventId: number): Promise<boolean> {
    let url: string = `${this._eventServiceBaseUrl}event/${eventId}/validate-custom-field-values`;
    return this._eventApiService.get(url);
  }
}
